import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import QueryFn from '../../../helpers/QueryFn';
import { trackEventMatomo,trackEventMatomoVisit } from '../../../helpers/matomo';
import Reports from '../../../service/Reports';
import type { ChecklistReportType } from '../../../types/reports/types';
import ModalDetailPrint from './ModalDetailPrint';

const queryFn = new QueryFn();
const reportsService = new Reports();

export default function LinkExterno() {
  const params = useParams();

  const userTimestamp = {
    user: params.user,
    timestamp: Number(params.timestamp)
  };

  const { data, isLoading, isSuccess, isError } = queryFn.useFetch('GET_LINK_EXTERNO',
    async () => {
      try {

        if (!params.timestamp) {
          const response = await reportsService.getExecutionById(String(params.formId));
          return response.execucao;
        } else {
          const response = await reportsService.getExecutionById(String(params.formId), userTimestamp);
          return response.execucao;
        }
      } catch (error) {
        console.error(error);
      }
    }
  );

  useEffect(() => {
    trackEventMatomoVisit('Visualização externa de formulário');
  }, []);

  useEffect(() => {
    if (isSuccess) trackEventMatomo('visualização externa de formulário', 'sucesso', 'carregamento', 'formulário carregado');
    if (isError) trackEventMatomo('visualização externa de formulário', 'erro', 'carregamento', 'falha ao carregar formulário');
  }, [isError, isSuccess]);

  return (
    !isLoading &&
    <ModalDetailPrint
      setOpenModal={() => { }}
      openModal={true}
      isLoadingLink={isLoading}
      selected={[data] as ChecklistReportType[]} />
  );
}
